import { render, staticRenderFns } from "./ConvocationRegistrationPublic.vue?vue&type=template&id=5427114b&scoped=true&"
import script from "./ConvocationRegistrationPublic.vue?vue&type=script&lang=js&"
export * from "./ConvocationRegistrationPublic.vue?vue&type=script&lang=js&"
import style0 from "./ConvocationRegistrationPublic.vue?vue&type=style&index=0&id=5427114b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5427114b",
  null
  
)

export default component.exports